import ObjectCache from './CacheService';
import LogicBaseNotificationApi from '../server/LogicBaseNotificationApi';
import UserAccount from '../UserAccount';
import LogicBaseNotification from '../../models/logicbasenotification';

class LogicBaseNotificationCache extends ObjectCache {
  api = LogicBaseNotificationApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseNotification(results._id, results.ct, results.ut, results.o, results.t, results.r, results.oid);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseNotificationCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
